import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Maximizar",
  "use": "Maximizar-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"Maximizar\"><path fill-rule=\"evenodd\" d=\"M14 0v12H0V0h14zm-1.75 4H1.75v6h10.5V4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol